import apiClient from './api';
import type { NetCashFlowByProductResponse, NetCashFlowReportResponse, ReportGroupBy } from '../types/report';

export const netCashFlowReportService = {
  // GET /api/activities/reports/net-cash-flow
  getReport: async (
    companyId: number,
    from: string,
    to: string,
    groupBy: ReportGroupBy
  ): Promise<NetCashFlowReportResponse> => {
    const response = await apiClient.get<NetCashFlowReportResponse>('/activities/reports/net-cash-flow', {
      params: { companyId, from, to, groupBy },
    });
    return response.data;
  },

  // GET /api/activities/reports/net-cash-flow/by-product
  getReportByProduct: async (
    companyId: number,
    from: string,
    to: string
  ): Promise<NetCashFlowByProductResponse> => {
    const response = await apiClient.get<NetCashFlowByProductResponse>('/activities/reports/net-cash-flow/by-product', {
      params: { companyId, from, to },
    });
    return response.data;
  },
};
